(function(angular){
    'use strict';

    angular.module('onvio.setup.migrations').service('migrationService', migrationService);
    migrationService.$inject = ['$q', '$http', '$translate', 'AuthenticatedSessionData', 'bmHttpUtils'];

    function migrationService($q, $http, $translate, AuthenticatedSessionData, bmHttpUtils) {

        var service = {
            getMigrationList: getMigrationList,
            getInstalledProducts: getInstalledProducts,
            getMigrationConfig: getMigrationConfig,
            createNewMigration: createNewMigration,
            getMigrationProductSets: getMigrationProductSets,
            deleteMigration: deleteMigration,
            getItemSetRefreshInfo: getItemSetRefreshInfo,
            getDateStringShort: getDateStringShort,
            normalizeName: normalizeName
        };
        return service;

        function getMigrationList(companyId, product) {
            var url = '/api/migrations/v1/companies/{companyId}/products/{product}/migrations';
            url = url.replace(/{companyId}/g, companyId);
            url = url.replace(/{product}/g, product);

            return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                   $http({url: url, method: 'GET', headers: {'Accept': 'application/json'} }));
        }

        function getInstalledProducts(companyId, contactId) {
            var url = '/api/migrations/v1/companies/{companyId}/contacts/{contactId}/migration-products';
            url = url.replace(/{companyId}/g, companyId);
            url = url.replace(/{contactId}/g, contactId);

            return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                   $http({url: url, method: 'GET', headers: {'Accept': 'application/json'} }));
        }

        function getMigrationProductSets(companyId, migrationProductId, dataPath) {
            var url = '/api/migrations/v1/companies/{companyId}/migration-products/{migrationProductId}/items?dataPath={encodedDataPath}';
            url = url.replace(/{companyId}/g, companyId);
            url = url.replace(/{migrationProductId}/g, migrationProductId);
            var encodedDataPath = encodeURIComponent(dataPath);
            url = url.replace(/{encodedDataPath}/g, encodedDataPath);

            return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                   $http({url: url, method: 'GET', headers: {'Accept': 'application/json'} }));
        }

        function createNewMigration(companyId, contactId, migrationProductId, migrationInfo) {
            var url = '/api/migrations/v1/companies/{companyId}/migration-products/{migrationProductId}/contacts/{contactId}/migrations';
            url = url.replace(/{companyId}/g, companyId);
            url = url.replace(/{migrationProductId}/g, migrationProductId);
            url = url.replace(/{contactId}/g, contactId);
            var strippedData = bmHttpUtils.getStrippedObject(migrationInfo, '$', 'Expanded');

            return bmHttpUtils.unwrapAndValidateHttpPromise(migrationInfo,
                    $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }));
        }

        function deleteMigration(companyId, contactId, migrationId) {
            var url = '/api/migrations/v1/companies/{companyId}/migrations/{migrationId}/contacts/{contactId}';
            url = url.replace(/{companyId}/g, companyId);
            url = url.replace(/{migrationId}/g, migrationId);
            url = url.replace(/{contactId}/g, contactId);

            return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                    $http({url: url, method: 'DELETE', params: {}, headers: {}}));
        }

        function getMigrationConfig() {
            return AuthenticatedSessionData.get().then(function(data) {
                var config = {
                    companyId: data.bindings.ApplicationConfiguration.CompanyId,
                    userId: data.meta.PrismGuid,
                    contactId: data.bindings.ApplicationConfiguration.ContactId,
                };
                return getInstalledProducts(config.companyId, config.contactId).then(function(resp) {
                        config.installedProducts = resp.items;
                        return config;
                    }, function(){
                        config.installedProducts = null;
                        return config;
                    });
                }, function() {
                   return undefined;
                });
        }

        function getItemSetRefreshInfo(companyId, migrationProductId) {
            var url = '/api/migrations/v1/companies/{companyId}/migration-products/{migrationProductId}/itemset-info';
            url = url.replace(/{companyId}/g, companyId);
            url = url.replace(/{migrationProductId}/g, migrationProductId);
            return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                   $http({url: url, method: 'GET', headers: {'Accept': 'application/json'}}));
        }

        function normalizeName(name) {
            if ( angular.isUndefined(name) || name === null){
                return null;
            }
            var str = '';
            var toUpper = true;
            var i;
            for(i = 0; i < name.length; i++) {
                if(name.charAt(i) === '-') {
                    toUpper = true;
                    continue;
                }
                if(toUpper) {
                    str += name.charAt(i).toUpperCase();
                    toUpper = false;
                } else {
                    str += name.charAt(i);
                }
            }
            return str;
        }

        function getDateStringShort(dateString) {
            if ( angular.isUndefined(dateString) ) {
                return '';
            }
            var dateObj = new Date(dateString);
            return ('0' + (dateObj.getUTCMonth() + 1)).slice(-2) + '/' + ('0' + dateObj.getUTCDate()).slice(-2) + '/' + dateObj.getUTCFullYear();
        }
    }

})(window.angular);
